import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSlide from './HeroSlide';
import HeroContent from './HeroContent';
import SchoolMembershipCard from './SchoolMembershipCard';
import ChatPreview from './ChatPreview';
import './HeroSlideshow.css';

const memberBenefits = [
  {
    text: "1 free complementary teacher's training on AI (worth $500!)",
  },
  {
    text: "5 free personalized school consultations (how to use AI to streamline processes, how to deal with AI usage by students)",
  },
  {
    text: "Monthly newsletter with latest AI trends that you should be caught up on (new tools that can help your school)",
  },
];

function HeroSlideshow({ className }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();
  
  const slides = [
    {
      id: 1,
      component: (
        <div className="hero-grid">
          <div className="hero-text-content">
            <HeroContent
              heading="AI Solutions streamlining processes for Islamic Schools"
              subheading="Nur Al Huda offers AI tools, School management system, and consulting to bring AI to our schools first."
            />
            <button 
              className="hero-button"
              onClick={() => navigate('/chat/nurAlHuda')}
            >
              Try now <span className="arrow-icon">→</span>
            </button>
          </div>
          <div className="hero-image-content">
            <ChatPreview />
          </div>
        </div>
      )
    },
    {
      id: 2,
      component: (
        <div className="hero-grid">
          <div className="hero-text-content">
            <HeroContent
              heading="Join other schools in North America as Nur Al Huda member schools"
              subheading="Get access to personalized trainings and consultations on how your schools can use AI and manage its usage by students for $250"
            />
            <button 
              className="hero-button"
              onClick={() => navigate('/pricing')}
            >
              Join Now <span className="arrow-icon">→</span>
            </button>
          </div>
          <div className="hero-image-content membership-card-container">
            <SchoolMembershipCard benefits={memberBenefits} />
          </div>
        </div>
      )
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        goToNextSlide();
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [currentSlide, isAnimating]);

  const goToNextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    
    // Pre-load the next slide by setting opacity to 1 before the transition
    const nextSlideIndex = (currentSlide + 1) % slides.length;
    const nextSlideElement = document.querySelector(`.slide[data-index="${nextSlideIndex}"]`);
    if (nextSlideElement) {
      nextSlideElement.style.opacity = 1;
    }
    
    setCurrentSlide(nextSlideIndex);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const goToPrevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    
    // Pre-load the previous slide by setting opacity to 1 before the transition
    const prevSlideIndex = (currentSlide === 0 ? slides.length - 1 : currentSlide - 1);
    const prevSlideElement = document.querySelector(`.slide[data-index="${prevSlideIndex}"]`);
    if (prevSlideElement) {
      prevSlideElement.style.opacity = 1;
    }
    
    setCurrentSlide(prevSlideIndex);
    setTimeout(() => setIsAnimating(false), 500);
  };

  return (
    <div className={`hero-slideshow ${className || ''}`}>
      <div className="gradient-bg" />
      <div className="radial-overlay" />
      
      <div className="slideshow-container">
        <div 
          className="slides-wrapper" 
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div 
              key={slide.id} 
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              data-index={index}
              style={{backgroundColor: "#2a9d8f"}}
            >
              <HeroSlide>
                {slide.component}
              </HeroSlide>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        className="nav-button prev"
        onClick={goToPrevSlide}
        aria-label="Previous slide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <button
        className="nav-button next"
        onClick={goToNextSlide}
        aria-label="Next slide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      {/* Dots navigation */}
      <div className="dots-container">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => {
              if (!isAnimating) {
                setIsAnimating(true);
                
                // Pre-load the clicked slide by setting opacity to 1 before the transition
                const clickedSlideElement = document.querySelector(`.slide[data-index="${index}"]`);
                if (clickedSlideElement) {
                  clickedSlideElement.style.opacity = 1;
                }
                
                setCurrentSlide(index);
                setTimeout(() => setIsAnimating(false), 500);
              }
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default HeroSlideshow; 